import React, { useId } from "react";
import PropTypes from "prop-types";

const paths = [
  "M1 21.75C1 21.1978 1.44772 20.75 2 20.75H22C22.5523 20.75 23 21.1978 23 21.75C23 22.3023 22.5523 22.75 22 22.75H2C1.44772 22.75 1 22.3023 1 21.75Z",
  "M4.02487 11.8531C4.39681 11.7714 4.81469 11.75 5.25 11.75H8.25C8.80228 11.75 9.25 12.1978 9.25 12.75C9.25 13.3023 8.80228 13.75 8.25 13.75H5.25C4.85798 13.75 4.61219 13.7718 4.454 13.8066C4.39488 13.8196 4.35937 13.8319 4.34003 13.8401C4.33188 13.8594 4.31951 13.8949 4.30652 13.954C4.27177 14.1122 4.25 14.358 4.25 14.75V21.75C4.25 22.3023 3.80228 22.75 3.25 22.75C2.69772 22.75 2.25 22.3023 2.25 21.75V14.75C2.25 14.3147 2.27139 13.8969 2.3531 13.5249C2.4373 13.1417 2.59857 12.7463 2.92239 12.4224C3.24621 12.0986 3.64161 11.9373 4.02487 11.8531Z",
  "M19.9751 11.8531C19.6032 11.7714 19.1853 11.75 18.75 11.75H15.75C15.1977 11.75 14.75 12.1978 14.75 12.75C14.75 13.3023 15.1977 13.75 15.75 13.75H18.75C19.142 13.75 19.3878 13.7718 19.546 13.8066C19.6051 13.8196 19.6406 13.8319 19.66 13.8401C19.6681 13.8594 19.6805 13.8949 19.6935 13.954C19.7282 14.1122 19.75 14.358 19.75 14.75V21.75C19.75 22.3023 20.1977 22.75 20.75 22.75C21.3023 22.75 21.75 22.3023 21.75 21.75V14.75C21.75 14.3147 21.7286 13.8969 21.6469 13.5249C21.5627 13.1417 21.4014 12.7463 21.0776 12.4224C20.7538 12.0986 20.3584 11.9373 19.9751 11.8531Z",
  "M13 2.25V4.00007H11V2.25C11 1.69772 11.4477 1.25 12 1.25C12.5523 1.25 13 1.69771 13 2.25Z",
  "M12 17.75C12.5523 17.75 13 18.1978 13 18.75V21.75C13 22.3023 12.5523 22.75 12 22.75C11.4477 22.75 11 22.3023 11 21.75V18.75C11 18.1978 11.4477 17.75 12 17.75Z",
  "M9.75 18.75C9.75 17.5074 10.7574 16.5 12 16.5C13.2426 16.5 14.25 17.5074 14.25 18.75V22.75H16C16.4142 22.75 16.75 22.4143 16.75 22V6.00005C16.75 5.57015 16.7282 5.17339 16.6523 4.82817C16.5746 4.47461 16.4298 4.12905 16.1504 3.84966C15.871 3.57026 15.5254 3.42543 15.1719 3.3477C14.8267 3.27186 14.4299 3.25005 14 3.25005H10C9.5701 3.25005 9.17335 3.27186 8.82812 3.3477C8.47457 3.42543 8.129 3.57026 7.84961 3.84966C7.57022 4.12905 7.42538 4.47461 7.34766 4.82817C7.27182 5.17339 7.25 5.57015 7.25 6.00005V22C7.25 22.4143 7.58579 22.75 8 22.75H9.75V18.75ZM11 7.02348C10.5858 7.02348 10.25 6.6877 10.25 6.27348C10.25 5.85927 10.5858 5.52348 11 5.52348H13C13.4142 5.52348 13.75 5.85927 13.75 6.27348C13.75 6.6877 13.4142 7.02348 13 7.02348H11ZM11 10.5235C10.5858 10.5235 10.25 10.1877 10.25 9.77348C10.25 9.35927 10.5858 9.02348 11 9.02348H13C13.4142 9.02348 13.75 9.35927 13.75 9.77348C13.75 10.1877 13.4142 10.5235 13 10.5235H11ZM11 14.0235C10.5858 14.0235 10.25 13.6877 10.25 13.2735C10.25 12.8593 10.5858 12.5235 11 12.5235H13C13.4142 12.5235 13.75 12.8593 13.75 13.2735C13.75 13.6877 13.4142 14.0235 13 14.0235H11Z",
];

const CompanyIcon = ({
  selected,
  width,
  height,
  className,
  ...props
}) => {
  const id = useId().replace(/:/g, "");
  const isActive = selected;
  const gradientIds = paths.map(
    (_, index) => `company-gradient-${index}-${id}`,
  );

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g opacity={isActive ? undefined : "0.5"}>
        {paths.map((path, index) => (
          <path
            key={path}
            fillRule="evenodd"
            clipRule="evenodd"
            d={path}
            fill={`url(#${gradientIds[index]})`}
          />
        ))}
      </g>
      <defs>
        {gradientIds.map((gradientId) => (
          <linearGradient
            key={gradientId}
            id={gradientId}
            x1="21.4769"
            y1="5.66517"
            x2="4.95023"
            y2="23.0856"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D946EF" />
            <stop offset="1" stopColor="#67E8F9" />
          </linearGradient>
        ))}
      </defs>
    </svg>
  );
};

CompanyIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

CompanyIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default CompanyIcon;
